import { useUserStore } from 'hooks/stores/useUserStore';
import { NextRouter } from 'next/router';
import { Dispatch, SetStateAction, useEffect } from 'react';
import { trackPageView } from 'utils/analytics/analytics';

export const useRouterEvents = (
  router: NextRouter,
  setLoading: Dispatch<SetStateAction<boolean>>,
) => {
  const userStore = useUserStore();
  useEffect(() => {
    const handleRouteChangeStart = () => {
      setLoading(true);
    };

    const handleRouteChangeComplete = (url: string) => {
      setLoading(false);
      trackPageView(
        url,
        userStore.currentUser?.emailAddress,
        userStore.currentUser?.id,
      );
    };

    const handleRouteChangeError = () => {
      setLoading(false);
    };

    router.events.on('routeChangeStart', handleRouteChangeStart);
    router.events.on('routeChangeComplete', handleRouteChangeComplete);
    router.events.on('routeChangeError', handleRouteChangeError);

    return () => {
      router.events.off('routeChangeStart', handleRouteChangeStart);
      router.events.off('routeChangeComplete', handleRouteChangeComplete);
      router.events.off('routeChangeError', handleRouteChangeError);
    };
  }, [router.events, setLoading, userStore]);
};
